import styled, { css } from "styled-components";

import { shimmer } from "shared/components/molecules/LoadingSkeleton/atoms/styles";

interface IContainerProps {
  squareFormat?: boolean;
  smallFormat?: boolean;
  hasInteraction?: boolean;
}

export const SimpleUserPhotoContainer = styled.div<IContainerProps>`
  :hover {
    cursor: pointer;
  }

  img {
    width: 1.5rem;
    height: 1.5rem;
    cursor: ${({ hasInteraction }) => hasInteraction && css`pointer`};
    padding: 0;
    border-radius: 50%;

    &[data-is-loading="true"] {
      background: linear-gradient(
        90deg,
        ${({ theme }) => (theme.mode === "dark" ? "#2F2F2F" : "#BEBEBE")} 25%,
        ${({ theme }) => (theme.mode === "dark" ? "#424242" : "#CECECE")} 50%,
        ${({ theme }) => (theme.mode === "dark" ? "#2F2F2F" : "#BEBEBE")} 75%
      );
      background-size: 200% 100%;

      animation: ${shimmer} 1.5s infinite ease-in-out;
    }
  }

  .userInitials {
    cursor: ${({ hasInteraction }) =>
      hasInteraction ? css`pointer` : css`default`};
    max-width: 42px !important;
    max-height: 42px !important;
    padding: 0;
    border-radius: 50%;
  }

  .SimpleUserInitialsName {
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${({ smallFormat }) =>
      smallFormat
        ? css`
          32px
        `
        : css`
          42px
        `} !important;

    height: ${({ smallFormat }) =>
      smallFormat
        ? css`
          32px
        `
        : css`
          42px
        `} !important;

    h1 {
      font-size: 12px;
      margin: 0;
    }
  }
`;
